// extracted by mini-css-extract-plugin
export default {"alert":"error-alert_alert__OBnhC","title":"error-alert_title__FO6Jf"};